import { render, staticRenderFns } from "./qualityinspectionabnorm.vue?vue&type=template&id=40bdbf00&scoped=true&"
import script from "./qualityinspectionabnorm.vue?vue&type=script&lang=js&"
export * from "./qualityinspectionabnorm.vue?vue&type=script&lang=js&"
import style0 from "./qualityinspectionabnorm.vue?vue&type=style&index=0&id=40bdbf00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bdbf00",
  null
  
)

export default component.exports